(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lunch-box-landing-page"] && !Shopify.designMode) return;
  try {
    
  class LunchBoxLandingPage {
    constructor(section) {
      this.section = section;
      this.gallery = section.querySelector('[data-lb-gallery]');
      this.form = section.querySelector('[data-lb-product-form]');
      this.initGallery();
      this.initPurchaseSelector();
    }

    initGallery() {
      if (!this.gallery) return;
      const thumbs = [...this.gallery.querySelectorAll('[data-lb-thumb]')];
      const slides = [...this.gallery.querySelectorAll('[data-lb-slide]')];
      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const index = thumb.dataset.lbThumb;
          thumbs.forEach((item) => item.classList.toggle('is-active', item === thumb));
          slides.forEach((slide) => slide.classList.toggle('is-active', slide.dataset.lbSlide === index));
        });
      });
    }

    initPurchaseSelector() {
      if (!this.form) return;
      this.modeInputs = [...this.form.querySelectorAll('[data-lb-purchase-mode]')];
      this.planList = this.form.querySelector('[data-lb-plan-list]');
      this.planSelect = this.form.querySelector('[data-lb-plan-select]');
      this.singlePlan = this.form.querySelector('[data-lb-single-plan]');
      this.subPrice = this.form.querySelector('[data-lb-sub-price]');
      this.subPerPack = this.form.querySelector('[data-lb-sub-per-pack]');
      this.oneTimePrice = this.form.querySelector('[data-lb-one-time-price]');
      this.submit = this.form.querySelector('[data-lb-submit]');
      this.submitText = this.form.querySelector('[data-lb-submit-text]');
      this.submitPrice = this.form.querySelector('[data-lb-submit-price]');

      this.modeInputs.forEach((input) => input.addEventListener('change', () => this.syncPurchaseMode()));
      this.planSelect?.addEventListener('change', () => this.syncPurchaseMode());
      this.submit?.addEventListener('click', () => this.rememberChoice());
      this.syncPurchaseMode();
    }

    getSelectedPlan() {
      if (this.planSelect) {
        const option = this.planSelect.options[this.planSelect.selectedIndex];
        return {
          id: this.planSelect.value,
          price: option?.dataset.price || '',
          perPack: option?.dataset.perPack || ''
        };
      }
      if (this.singlePlan) {
        return {
          id: this.singlePlan.dataset.planId || '',
          price: this.singlePlan.dataset.price || '',
          perPack: this.singlePlan.dataset.perPack || ''
        };
      }
      return null;
    }

    selectedMode() {
      return this.modeInputs.find((input) => input.checked)?.value || 'one_time';
    }

    buildDestination(baseUrl, mode, planId = '') {
      if (!baseUrl) return '#';
      if (this.form.dataset.passChoice !== 'true') return baseUrl;
      try {
        const url = new URL(baseUrl, window.location.origin);
        url.searchParams.set('lb_purchase', mode);
        if (mode === 'subscription' && planId) {
          url.searchParams.set('selling_plan', planId);
        } else {
          url.searchParams.delete('selling_plan');
        }
        return url.toString();
      } catch (error) {
        return baseUrl;
      }
    }

    rememberChoice() {
      const mode = this.selectedMode();
      const plan = this.getSelectedPlan();
      try {
        sessionStorage.setItem('lb_purchase_mode', mode);
        if (mode === 'subscription' && plan?.id) {
          sessionStorage.setItem('lb_selling_plan', plan.id);
        } else {
          sessionStorage.removeItem('lb_selling_plan');
        }
      } catch (error) {}
    }

    syncPurchaseMode() {
      const mode = this.selectedMode();
      const plan = this.getSelectedPlan();

      if (mode === 'subscription' && plan) {
        this.planList?.classList.remove('is-hidden');
        if (this.subPrice && plan.price) this.subPrice.textContent = plan.price;
        if (this.subPerPack && plan.perPack) this.subPerPack.textContent = plan.perPack;
        if (this.submitText) this.submitText.textContent = this.form.dataset.subscriptionLabel;
        if (this.submitPrice) this.submitPrice.textContent = this.form.dataset.showButtonPrice === 'true' && plan.price ? ` — ${plan.price}` : '';
        if (this.submit) this.submit.href = this.buildDestination(this.form.dataset.subscriptionUrl, 'subscription', plan.id);
      } else {
        this.planList?.classList.add('is-hidden');
        if (this.submitText) this.submitText.textContent = this.form.dataset.oneTimeLabel;
        if (this.submitPrice) this.submitPrice.textContent = this.form.dataset.showButtonPrice === 'true' && this.oneTimePrice ? ` — ${this.oneTimePrice.textContent}` : '';
        if (this.submit) this.submit.href = this.buildDestination(this.form.dataset.oneTimeUrl, 'one_time');
      }
    }
  }

  const initLunchBoxSections = (root = document) => {
    root.querySelectorAll('[id^="LunchBox-"]').forEach((section) => {
      if (section.dataset.lbInitialized === 'true') return;
      section.dataset.lbInitialized = 'true';
      new LunchBoxLandingPage(section);
    });
  };

  document.addEventListener('DOMContentLoaded', () => initLunchBoxSections());
  document.addEventListener('shopify:section:load', (event) => initLunchBoxSections(event.target));

  } catch(e) { console.error(e); }
})();
})();
